export function CryptoIcon({ name, size = '24px', variant = 'color', style, className }: any) {
  const ticker = name.toLowerCase();
  const src = require(`cryptocurrency-icons/svg/${variant}/${ticker}.svg`);

  return (
    <img
      src={src}
      alt={`${name} icon`}
      width={size}
      height={size}
      style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
      className={className}
      onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
    />
  );
}